import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '@osc-utils/services/spinner.service';
import { forkJoin, Subscription } from 'rxjs';
import { CommonConfirmDialogComponent } from 'src/app/common-dialog/common-confirm-dialog/common-confirm-dialog.component';
import { ElementType, PropOrElemType } from 'src/app/_objects/element-type';
import { PropertyPanelDef } from 'src/app/_objects/interfaces/property-panel';
import { ReportProperties } from 'src/app/_objects/report-properties';
import { ReportTemplate, TemplateCustomPageSection, TemplateDefinition } from 'src/app/_objects/report-template';
import { CommonSnackBarService } from 'src/app/_services/common-snack-bar.service';
import { LangUpdateService } from 'src/app/_services/lang-update.service';
import { ReportComponentService } from 'src/app/_services/report-component.service';
import { MousePoint, Notifier, ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';
import { DYNAMIC_SELECT_ITEM } from '../../app.constants'

namespace ButtonColors {
  export const Selected = 'accent';
  export const None = 'primary';
}

@Component({
    selector: 'app-create-custom-element',
    templateUrl: './create-custom-element.component.html',
    styleUrls: ['./create-custom-element.component.scss'],
    standalone: false
})
export class CreateCustomElementComponent implements OnInit {
  private notifier: Notifier;
  public buttonColors: { [buttonName: string]: string };
  public selectedPage: any;
  public reportPageKeys: Array<string>;
  public pageKey: string;
  public customElementName: string;
  public selectedPropPanels: PropertyPanelDef[];
  public showMenu: string;
  private mySubscriber: Subscription[];
  public selectedElements: any = [];
  private lastClickedPoint: MousePoint;
  public isActionCut: boolean;
  public applications: string[] = [this.translate.instant('createcustomElement.ViSOL'), this.translate.instant('createcustomElement.IPM'), this.translate.instant('createcustomElement.Generic')];
  public application: string;
  public isUpdateCustomElement: boolean;
  public customTemplateId: string;
  public customTemplateName: string;
  constructor(public designService: ReportTemplateDesignService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private snackBar: CommonSnackBarService,
    private reportComponentService: ReportComponentService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private langService: LangUpdateService
  ) {
    this.langService.prepare(
      this,
      this.translate,
      (res) => {
        this.applications[0] = this.translate.instant('createcustomElement.ViSOL');
        this.applications[1] = this.translate.instant('createcustomElement.IPM');
        this.applications[2] = this.translate.instant('createcustomElement.Generic');
      }
    );
    DYNAMIC_SELECT_ITEM.push(
      { label: 'visualEvent.description', value: 'visualEvent.description' },
      { label: 'visualEvent.eventId', value: 'visualEvent.eventId' },
      { label: 'visualEvent.imageUrls', value: 'visualEvent.imageUrls' },
      { label: 'visualEvent.isPhotoOnlyEvent', value: 'visualEvent.isPhotoOnlyEvent' },
      { label: 'visualEvent.label', value: 'visualEvent.label' },
      { label: 'visualEvent.location', value: 'visualEvent.location' },
      { label: 'visualEvent.visualEventPriority', value: 'visualEvent.visualEventPriority' },
      { label: 'visualEvent.visualEventStatus', value: 'visualEvent.visualEventStatus' },
      { label: 'visualEvent.visualEventType', value: 'visualEvent.visualEventType' }
    )
    this.customTemplateName = this.route.snapshot.queryParamMap.get('name');
    this.isUpdateCustomElement = this.customTemplateName ? true : false;
    this.customTemplateId = this.route.snapshot.queryParamMap.get('id');
    this.designService.highlightElement = false;
    this.designService.clickedPageIdForDelete = '';
    this.mySubscriber = [];
    this.mySubscriber.push(
      this.designService.onReady.subscribe((message: string) => {
        this.designService.notifyChangeScroll(
          this.notifier,
          this.designService.getPageIds()[0]
        );
        this.viewSelectedElement();
      })
    );
    this.mySubscriber.push(
      this.designService.onSelectedElement.subscribe((message: string) => {
        this.viewSelectedElement();
      })
    );
    this.mySubscriber.push(
      this.designService.onEndDraw.subscribe((message: string) => {
        // 全てのボタンの色を「選択無し」の色にする
        Object.keys(this.buttonColors).forEach((propName: string) => {
          this.buttonColors[propName] = ButtonColors.None;
        });
      })
    );
    this.buttonColors = {
      text: ButtonColors.None,
      line: ButtonColors.None,
      image: ButtonColors.None,
      rectangle: ButtonColors.None,
      summary: ButtonColors.None,
      picture: ButtonColors.None,
      dataPlate: ButtonColors.None,
      measurementPoint: ButtonColors.None,
      visualEvents: ButtonColors.None,
      signature: ButtonColors.None,
      section: ButtonColors.None,
      table: ButtonColors.None,
      interactiveIso: ButtonColors.None,
      dropDownList: ButtonColors.None,
    };
  }

  ngOnInit(): void {
    if (!this.isUpdateCustomElement) {
      this.designService.notifyAddCustomPage(); //Adding a new page and filter the added page for custom draw below
      this.reportPageKeys = this.designService.getPageIds();
      this.pageKey = this.designService.customElementPageKey = this.reportPageKeys[this.reportPageKeys.length - 1];
    }
    else {
      this.spinnerService.show(this.spinnerService.mainSpinnerId);
      const requests = [
        this.reportComponentService.getReportCompopent(this.customTemplateName),
        this.reportComponentService.getTemplateComponent(this.customTemplateName)
      ];
      forkJoin(requests).subscribe((res) => {
        this.application = res[0].application;
        this.customElementName = res[0].name;
        const template: ReportTemplate = this.designService.originTemplate;
        const tempDef: TemplateDefinition = template.template;
        tempDef.bodies = [];
        tempDef.bodies.push(res[1]);
        template.template = tempDef;
        this.designService.reloadTemplate(template, true);
        this.pageKey = this.designService.getPageIds()[0];
      },
        (err) => {
          console.error(err);
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        },
        () => {
          this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        })
    }
  }
  @HostListener('window:keydown', ['$event'])
  public onKeyPress($event: any) {
    if ($event.target.tagName === 'INPUT' || $event.target.tagName === 'TEXTAREA') {
      return;
    }
    if ($event.key === 'Delete') {
      this.deleteSelectedElement();
    }
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 90) {
      if (this.designService.templateForUndo.length > 0) {
        //this.undoElement();
      }
    }
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 89) {
      if (this.designService.templateForRedo.length > 0) {
        //this.redoElement();
      }
    }
  }
  @HostListener('mousemove', ['$event'])
  public handleMousemove(event) {
    this.lastClickedPoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY,
    };
  }
  public openSaveDialog() {
    const dialogRef = this.dialog.open(CommonConfirmDialogComponent, {
      width: '500px',
      height: '230px',
      data: {
        firstMessage: this.translate.instant('createcustomElement.suretoSave'),
        secondMessage: '',
        cancellable: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.spinnerService.show(this.spinnerService.mainSpinnerId);
        if (!this.isUpdateCustomElement) {
          this.designService.customTemplateDefinition = this.designService.getTemplate().bodies[this.designService.getTemplate().bodies.length - 1] as TemplateCustomPageSection;
          this.designService.saveCustomTemplate(this.customElementName, this.application).subscribe(res => {
          },
            () => {
              this.snackBar.open(this.translate.instant('createcustomElement.saveFailed'));
              this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            },
            () => {
              this.snackBar.open(this.translate.instant('createcustomElement.saveSuccessful'));
              this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            });
        }
        else {
          const updateTemplate = JSON.stringify(this.designService.getTemplate().bodies[0]);
          this.reportComponentService.updateCustomTemplate(this.customTemplateId, updateTemplate, this.customElementName, this.application).subscribe(() => {

          },
            () => {
              this.snackBar.open(this.translate.instant('createcustomElement.saveFailed'));
              this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            }, () => {
              this.snackBar.open(this.translate.instant('createcustomElement.saveSuccessful'));
              this.spinnerService.hide(this.spinnerService.mainSpinnerId);
            })
        }
      }
    });
  }

  public cancel() {
    if (this.designService.reportTemplateId) {
      this.router.navigateByUrl(`/report-template-design/${this.designService.reportTemplateId}`);
    }
    else {
      this.router.navigateByUrl(`/template-list`);
    }
  }

  public onSelectObjectMenu(objectName: string, action: string) {
    this.designService.highlightElement = true;
    switch (action) {
      case 'add':
        Object.keys(this.buttonColors).forEach((propName: string) => {
          this.buttonColors[propName] = ButtonColors.None;
        });
        this.designService.notifyAddPage(this.notifier);
        break;

      case 'draw':
        const elementType: ElementType = ElementType.cast(objectName);
        if (this.buttonColors[objectName] === ButtonColors.None) {
          Object.keys(this.buttonColors).forEach((propName: string) => {
            this.buttonColors[propName] = ButtonColors.None;
          });
          this.buttonColors[objectName] = ButtonColors.Selected;
          this.designService.notifyDrawMode(this.notifier, elementType);
        } else {
          this.designService.notifyDrawCancel(this.notifier);
        }
        break;

      case 'delete':
        Object.keys(this.buttonColors).forEach((propName: string) => {
          this.buttonColors[propName] = ButtonColors.None;
        });
        this.designService.notifyDelete(this.notifier);
        break;

      case 'selectAll':
      case 'selectByPage':
        break;

      default:
        break;
    }
  }

  public onClick(event: MouseEvent) {
    this.designService.notifyDeselectAll(this.notifier, event.ctrlKey);
    this.designService.highlightElement = false;
  }

  public scrollEvent(eve) {
    const pageNo = Math.floor(
      eve.target.scrollTop / (this.designService.getPaperHeightPx() + 8)
    ); // ページ間隔8pxを足す
    this.designService.notifyChangeScroll(
      this.notifier,
      this.designService.getPageIds()[pageNo]
    );
  }

  public onMouseDown($event: MouseEvent) {
    const selectedElements: any =
      this.designService.getSelectedElementProperties();
    const summaryIds = this.designService.getSummaryIds(
      selectedElements[0].getId(),
      'Body'
    );
    summaryIds.forEach((id: string) => {
      console.log('summary ids');
      console.log(id);
      console.log(this.designService.getSummary(id));
    });

    this.selectedPage = selectedElements.find(
      (el) => el.type.toLowerCase() === 'page'
    );
  }

  public viewSelectedElement() {
    const selectedElemProps: ReportProperties[] =
      this.designService.getSelectedElementProperties();
    this.selectedPropPanels = [];
    selectedElemProps.forEach((reportProperties: ReportProperties) => {
      const type = this.getPanelType(reportProperties.getPropOrElemType());
      if (type !== 'Page') {
        this.selectedPropPanels.push({
          propId: reportProperties.getId(),
          title: reportProperties.getTitle(),
          propOrElemType: reportProperties.getPropOrElemType(),
          mapTableData: reportProperties.getMapProperties(),
        });
        this.showMenu = 'properties';
      }
    });
  }

  public getPanelType(propOrElemType: PropOrElemType): string {
    const types: ElementType[] = [
      ElementType.Page,
      ElementType.Text,
      ElementType.Line,
      ElementType.Image,
      ElementType.Rectangle,
      ElementType.Summary,
      ElementType.Picture,
      ElementType.DataPlate,
      ElementType.InteractiveIso,
      ElementType.DropDownList,
    ];
    for (const type of types) {
      if (propOrElemType.indexOf(type) === 0) {
        return type;
      }
    }
    return null;
  }

  public deleteSelectedElement(): void {
    const elementUndo = { ...this.designService.originTemplate };
    elementUndo.reportTemplateContent = JSON.stringify(
      this.designService.getTemplate()
    );
    this.designService.templateForUndo.push(elementUndo);

    this.designService.notifyDelete(this.notifier);
    //this.propertyValidate();
  }
  public undoElement(): void {
    const templateRedo = { ...this.designService.originTemplate };
    templateRedo.reportTemplateContent = JSON.stringify(
      this.designService.getTemplate()
    );
    this.designService.templateForRedo.push(templateRedo);

    const element = JSON.parse(
      JSON.stringify(this.designService.templateForUndo.pop())
    );
    element.template = element.reportTemplateContent
      ? JSON.parse(element.reportTemplateContent)
      : new TemplateDefinition();
    this.designService.loadReportTemplate(element, true);
  }

  public redoElement(): void {
    const elementUndo = { ...this.designService.originTemplate };
    elementUndo.reportTemplateContent = JSON.stringify(
      this.designService.getTemplate()
    );
    this.designService.templateForUndo.push(elementUndo);

    const element = JSON.parse(
      JSON.stringify(this.designService.templateForRedo.pop())
    );
    element.template = element.reportTemplateContent
      ? JSON.parse(element.reportTemplateContent)
      : new TemplateDefinition();
    this.designService.loadReportTemplate(element, true);
  }
}
